import { ITEM_TYPES } from '@wix/advanced-seo-utils'
import {
  getPattern,
  savePattern,
  deletePattern,
} from '@wix/ambassador-document-management-live-site-data-v1-seo-pattern/http'
import type { SeoSchema } from '@wix/ambassador-document-management-live-site-data-v1-seo-pattern/types'
import type { HttpClient } from '@wix/http-client'

const getItemPagePatternType = (pageId: string) =>
  `${ITEM_TYPES.WIX_DATA_PAGE_ITEM}-${pageId}`

export const getItemPageSeoSchema = async ({
  httpClient,
  pageId,
}: {
  httpClient: HttpClient
  pageId: string
}): Promise<SeoSchema | undefined> => {
  const { data } = await httpClient.request(
    getPattern({ patternType: getItemPagePatternType(pageId) }),
  )
  return data?.pattern?.content
}

export const saveItemPageSeoSchema = async ({
  httpClient,
  pageId,
  seoSchema,
}: {
  httpClient: HttpClient
  pageId: string
  seoSchema: SeoSchema
}): Promise<void> => {
  await httpClient.request(
    savePattern({
      pattern: {
        content: seoSchema,
        patternType: getItemPagePatternType(pageId),
      },
    }),
  )
}

export const deleteItemPageSeoSchema = async ({
  httpClient,
  pageId,
}: {
  httpClient: HttpClient
  pageId: string
  isListPage?: boolean
}): Promise<void> => {
  await httpClient.request(
    deletePattern({ patternType: getItemPagePatternType(pageId) }),
  )
}
